import React, { useState, useEffect } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
import MenuComplete from './MenuComplete';
import './Navbar.css';
import { IconContext } from 'react-icons';

import GetCurrentToken from '../app/GetCurrentToken';
import { GetCurrentModuleName } from './MenuComplete';

function Navbar() {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  const userToken = GetCurrentToken();
  const userName = userToken.userTokenData.username;

  const [addModules, setModules] = useState(false);
  const userPermits = userToken.userTokenData.permissions;
  const [SidebarData, setSidebarData] = useState([]);
  const [viewNameModule, setViewNameModule] = useState('Admin Nerthus');
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const toggleSidebar = () => setSidebar(!sidebar);

  useEffect(() => {
    if (!sidebar) {
      const updatedSidebarData = SidebarData.map((item) => ({
        ...item,
        subMenuOpen: false
      }));
      setSidebarData(updatedSidebarData);
    }
  }, [sidebar]);

  useEffect(() => {
    if (!addModules) {
      const filteredMenu = validatePermissions(MenuComplete);
      setSidebarData(filteredMenu);
      setModules(true);
    }
  }, [addModules, userPermits, SidebarData]);

  useEffect(() => {
    setViewNameModule(GetCurrentModuleName());
  }, [window.location.pathname]);

  const validatePermissions = (menu) => {
    const filteredMenu = [];

    for (const item of menu) {
      const filtered = userPermits.filter(validItem => validItem === item.permission || validItem.startsWith(item.permission + '_'));
      if (item.permission === '' || filtered.length > 0) {
        if (item.subMenu && item.subMenu.length > 0) {
          const subMenuItems = validatePermissions(item.subMenu);
          if (subMenuItems.length > 0) {
            item.subMenu = subMenuItems;
            filteredMenu.push(item);
          }
        } else {
          filteredMenu.push(item);
        }
      }
    }

    return filteredMenu;
  };

  const handleSubMenuClick = (index) => {
    if (openSubMenu === index) {
      setOpenSubMenu(null);
    } else {
      setOpenSubMenu(index);
    }
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className='navbar'>

          <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>

          <div className="navbar-content" style={{ color: '#fff', fontSize: '20px' }}>
            {viewNameModule}
          </div>

          <div style={{ float: 'right', padding: '8px' }}>
            <LogoutButton userName={userName} />
          </div>

        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'} style={{ overflowY: 'auto' }}>
          <ul className='nav-menu-items' style={{ paddingLeft: '0' }}>
            <li key={'keyToggle'} className='navbar-toggle'>
              <Link to='#' className='menu-bars' onClick={showSidebar}>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => (
              <MenuItem
                key={index}
                item={item}
                index={index}
                openSubMenu={openSubMenu}
                handleSubMenuClick={handleSubMenuClick}
                toggleSidebar={toggleSidebar}
              />
            ))}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

const MenuItem = ({ item, index, openSubMenu, handleSubMenuClick, toggleSidebar }) => {
  const hasSubMenu = item.subMenu && item.subMenu.length > 0;

  return (
    <>
      {hasSubMenu ? (
        <li className='nav-text' onClick={() => handleSubMenuClick(index)} style={{ color: 'white', cursor: 'pointer' }}>
          <a>
            {item.icon}
            <span>{item.title}</span>
            {openSubMenu === index ? <AiIcons.AiOutlineUp /> : <AiIcons.AiOutlineDown />}
          </a>
        </li>
      ) : (
        <li className='nav-text' onClick={() => {
          toggleSidebar();
          handleSubMenuClick(-1);
        }}>
          <Link to={item.path}>
            {item.icon}
            <span>{item.title}</span>
          </Link>
        </li>
      )}

      {hasSubMenu && openSubMenu === index && (
        item.subMenu.map((subItem, subIndex) => (
          <li
            key={`${index}-${subIndex}-itemSubMenu`}
            className='nav-text'
            style={{ backgroundColor: '#273143' }}
            onClick={toggleSidebar}
          >
            <Link to={subItem.path}>
              {subItem.icon}
              <span style={{ fontSize: '15px' }}>{subItem.title}</span>
            </Link>
          </li>
        ))
      )}
    </>
  );
};

const LogoutButton = ({ userName }) => {
  const styleButton = {
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    padding: 6,
    display: "inline-flex",
    border: "none",
    borderRadius: "50%",
    boxShadow: "1px 1px 2px 0px rgb(0 0 0 / .3)"
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <button
      title={`Logout ${userName}`}
      style={styleButton}
      onClick={handleLogout}
    >
      <FaIcons.FaSignOutAlt color="white" size={25} />
    </button>
  );
};

export default Navbar;
